module.exports = __webpack_public_path__ + "img/hc_pro_eight_3.29862c69.jpg";